import React from 'react';
import monitoringService from '../../services/monitoringService';

/**
 * PR Manager - Global Hata Yakalayıcı (Error Boundary)
 * Uygulamanın tamamen çökmesini engeller ve hatayı loglar.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Bir sonraki render'da hata arayüzünü göster
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Hatayı dahili monitoring servisine gönder
    monitoringService.logError(error, {
      componentStack: errorInfo.componentStack,
      level: 'fatal',
      location: 'ErrorBoundary'
    });
  }

  render() {
    if (this.state.hasError) {
      const errorMsg = this.state.error?.toString() || '';
      const isChunkOrNetworkError = 
        !navigator.onLine || 
        errorMsg.includes('ChunkLoadError') || 
        errorMsg.includes('Loading chunk') || 
        errorMsg.includes('Failed to fetch') ||
        errorMsg.includes('NetworkError');

      if (isChunkOrNetworkError) {
        return (
          <div className="min-h-screen flex items-center justify-center bg-slate-900 px-4 text-white">
            <div className="max-w-md w-full bg-slate-800 rounded-3xl shadow-2xl p-8 text-center border border-slate-700">
              <div className="w-20 h-20 bg-amber-500/10 border border-amber-500/30 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-4xl">🔌</span>
              </div>
              <span className="inline-block px-3 py-1 bg-amber-500/20 text-amber-400 rounded-full text-[10px] font-black uppercase tracking-wider mb-3">
                Çevrimdışı Kasa Modu
              </span>
              <h1 className="text-2xl font-black text-white mb-2">İnternet Bağlantısı Kesildi</h1>
              <p className="text-slate-400 text-sm mb-6 leading-relaxed">
                Ağ bağlantısı kesildiği için sayfa bileşeni yüklenemedi. Yerel verileriniz ve siparişleriniz güvende tutulmaktadır.
              </p>
              <div className="space-y-3">
                <button
                  onClick={() => window.location.reload()}
                  className="w-full bg-sky-600 hover:bg-sky-500 text-white font-bold py-3 rounded-2xl transition-all shadow-lg shadow-sky-600/20 active:scale-95"
                >
                  Sayfayı Yeniden Yükle
                </button>
                <button
                  onClick={() => {
                    // Yerel Kasa sunucusu varsa oraya geçmeyi dene
                    window.location.href = 'http://localhost:4005';
                  }}
                  className="w-full bg-slate-700 hover:bg-slate-600 text-slate-200 font-bold py-3 rounded-2xl transition-all active:scale-95 text-xs"
                >
                  🏠 Yerel Kasa Sunucusunu Aç (Port 4005)
                </button>
              </div>
            </div>
          </div>
        );
      }

      // Standart hata durumunda gösterilecek şık arayüz
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
          <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-8 text-center border border-red-50">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-4xl">⚠️</span>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Eyvah, bir şeyler ters gitti!</h1>
            <p className="text-gray-600 mb-8">
              Beklenmedik bir hata oluştu. Mühendislerimiz bilgilendirildi ve sorunu çözmek için çalışıyorlar.
            </p>
            <div className="space-y-3">
              <button
                onClick={() => window.location.reload()}
                className="w-full bg-blue-600 text-white font-semibold py-3 rounded-2xl hover:bg-blue-700 transition-all shadow-lg shadow-blue-200"
              >
                Sayfayı Yenile
              </button>
              <button
                onClick={() => window.location.href = '/'}
                className="w-full bg-gray-100 text-gray-700 font-semibold py-3 rounded-2xl hover:bg-gray-200 transition-all"
              >
                Ana Sayfaya Dön
              </button>
            </div>
            {process.env.NODE_ENV !== 'production' && (
              <div className="mt-8 p-4 bg-red-50 rounded-xl text-left overflow-auto max-h-40">
                <p className="text-xs font-mono text-red-700 break-words">
                  {this.state.error?.toString()}
                </p>
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
